import type { OnboardingStep } from '@/hooks/use-onboarding'
import { WELCOME_STEP_ID } from '@/lib/onboarding-display'

export function onboardingWelcomeHeaderFromSteps(steps: OnboardingStep[]): {
  title: string
  description: string
} {
  const welcome = steps.find((step) => step.id === WELCOME_STEP_ID)
  return {
    title: welcome?.title ?? 'Welcome',
    description: welcome?.description ?? '',
  }
}

export function firstIncompleteCountedStepId(
  countedSteps: OnboardingStep[],
  completedStepIds: string[],
): string | null {
  const completed = new Set(completedStepIds)
  return countedSteps.find((step) => !completed.has(step.id))?.id ?? null
}
